package navigation.settings.countries.addeditcountry

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.country.domain.repository.CountryRepository
import com.essntl.features.country.domain.usecase.AddEditCountryUseCase
import com.essntl.features.country.ui.addeditcountry.AddEditCountryEvent
import com.essntl.features.country.ui.addeditcountry.AddEditCountryState
import com.essntl.features.country.ui.addeditcountry.AddEditCountryValidation
import com.essntl.features.country.ui.addeditcountry.AddEditCountryViewModel
import com.essntl.toastmanager.ToastManager

class AddEditCountryScreenModel(
    countryRepository: CountryRepository,
    areaRepository: AreaRepository,
    addEditCountryUseCase: AddEditCountryUseCase,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditCountryState>(AddEditCountryState()) {

    val validation = AddEditCountryValidation()

    private val viewModel =
        AddEditCountryViewModel(
            countryRepository = countryRepository,
            areaRepository = areaRepository,
            addEditCountryUseCase = addEditCountryUseCase,
            loadingManager = loadingManager,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: AddEditCountryEvent) = viewModel.onEvent(event)
}